import { memo } from "react";
import makeStyles from '@mui/styles/makeStyles';
import BasicButton from "./Buttons/BasicButton";

const useStyles = makeStyles(theme =>({
    root: {
        border: "1px solid currentColor",
        borderRadius: '0px',
        color: theme.palette.secondary.light,
        padding: ".25rem 1rem",
        '& svg path' : {
            fill: 'currentColor',
        },
        '&:hover': {
            borderColor: 'currentColor',
            color: theme.palette.primary.light,
        },
        /*'&:active':{
            borderColor: 'currentColor',
            color: theme.palette.secondary.contrastText,
        },*/
        '& .MuiButton-startIcon': {
            marginRight: theme.spacing(1)
        }
    },
    rootActive: {
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
    },
    'btnNoText': {
        '& .MuiButton-startIcon': {
            marginRight: theme.spacing(0)
        }
    }
}));

export default memo(function OutlinedButton ({ icon, isActive = false, className = "", onClick = undefined, buttonProps = {}, ...props}) {

    const classes = useStyles();

    const Icon = icon;
    
    const classArray = [
        classes.root,
        className,
        !props.text ? classes.btnNoText : "",
        isActive ? classes.rootActive : null,
    ].filter(x => x);

    const displayProps = {
        color: 'secondary',
        className: classArray.join(" "),
        startIcon: Icon,
        onClick: onClick,
        ...props,
        ...buttonProps,
    };

    return (
        <>
            <BasicButton {...displayProps}>
                {props.text}
            </BasicButton>
        </>
    );
});